import { Select, styled } from '@mui/material';
import { GivelifyTextField } from '../textField';

export const SelectCountry = styled(Select)({
    minWidth: 60,
    '& .MuiSelect-icon': {
        width: 24,
        height: 24,
        top: 'auto',
    },
});

export const SelectFlag = styled('img')({
    verticalAlign: 'middle',
    marginLeft: 16,
});

export const FlagImage = styled('img')({ marginRight: 8 });

export const StyledCityField = styled(GivelifyTextField)({
    '& .MuiOutlinedInput-root': {
        padding: 0,
        height: 56,
    },
    '& .MuiInputLabel-root:not(.MuiInputLabel-shrink)': {
        transform: 'translate(82px, 16px)',
    },
    '& .MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
        paddingRight: 0,
    },
});
